import Network from 'infrastructure/js/modules/network';

export function getWhitelistSettings() {
  return Network.get('whitelist');
}

export function submitWhitelistSettings(data) {
  return Network.put('whitelist', data);
}
